import Vue from 'vue';
 

new Vue({
  el: '#togglebtnOpen',

  methods: {
    
    modal: function () {

      let body = document.getElementsByTagName("body")[0];
      let modal = document.getElementById("livesearch");

      body.classList.add("search-open");
      modal.classList.add("open");
      modal.classList.remove("invisible");

      modal.setAttribute('aria-hidden', false);
      this.$refs.openSearch.setAttribute('aria-expanded', true);

      setTimeout(function(){ 
        document.getElementById("closeBtn").focus();
      }, 100);

      
    
    },
    
  }
})


new Vue({
  el: '#togglebtnClose',

  methods: {
    
    modal: function () {

      let body = document.getElementsByTagName("body")[0];
      let modal = document.getElementById("livesearch");
      let button = document.getElementById("search-toggle");

      body.classList.remove("search-open");
      modal.classList.remove("open");
      modal.classList.add("invisible");

      modal.setAttribute('aria-hidden', true);
      button.setAttribute('aria-expanded', false);

      document.getElementById("search-toggle").focus();
     
    
    },
    
  }
})


new Vue({
  el: '#togglebtnOpenWeather',

  methods: {

    modal: function () {

      let body = document.getElementsByTagName("body")[0];
      let modal = document.getElementById("weather");

      body.classList.add("search-open");
      modal.classList.add("open");
      modal.classList.remove("invisible");

      modal.setAttribute('aria-hidden', false);
      this.$refs.openWeather.setAttribute('aria-expanded', true);

      setTimeout(function(){
        document.getElementById("closeWeather").focus();
      }, 100);
      
    
    },
    
  }
})


new Vue({
  el: '#togglebtnCloseWeather',

  methods: {
    
    modal: function () {

      let body = document.getElementsByTagName("body")[0];
      let modal = document.getElementById("weather");
      let button = document.getElementById("openWeather");

      body.classList.remove("search-open");
      modal.classList.remove("open");
      modal.classList.add("invisible");

      modal.setAttribute('aria-hidden', true);
      button.setAttribute('aria-expanded', false);

      setTimeout(function(){
        document.getElementById("openWeather").focus();
      }, 100);
    
    },

  }
})

